import React, { useEffect, useState, useRef } from "react";
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
const UploadImage = ({ register, errors, onFileChange, setValue }) => {
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState(null);
  const fileInputRef = useRef(null);
const { t } = useTranslation();
  const handleImageChange = (e) => {
   
    const file = e.target.files[0];
   
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      
      if (objectUrl != preview) {
        setPreview(objectUrl);
      }
      setValue("imgprofile", file);
      setFileName(file.name);
      if (onFileChange) {
        onFileChange(file);
      }
    }
  };
  
  return (
    <>
    <style>
      {`
        .custom-file-name {
          width: 100%;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          cursor: pointer;
          background-color: #f8f9fa;
          font-size: 16px;
          color: #333;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      `}
    </style>
    <div className="input-block mb-3">
      <div className="d-flex justify-content-center mt-4" >
        <div className="position-relative mb-3 rounded border border-secondary d-flex justify-content-center align-items-center overflow-hidden bg-light" style={{ width: '150px', height: '150px', cursor: 'pointer' }} onClick={() => fileInputRef.current.click()}>
          {preview ? (
            <img
              src={preview}
              alt="Profile"
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
            />
          ) : (
            <Icon.Briefcase size={40}/>
          )}
        </div>
      </div>
      <label htmlFor="upload-photo">{t("Upload Company Logo")}</label>
      <input
        id="upload-photo"
        type="file"
        name="imgprofile"
        accept="image/*"
        ref={(e) => {
          fileInputRef.current = e;
          register("imgprofile").ref(e); // Attach React Hook Form's register to the ref
        }}
        onChange={handleImageChange}
        className="form-control"
        style={{ display: "none" }}
      />
      {/* Custom file name display */}
      <input
        type="text"
        className="form-control custom-file-name"
        value={fileName || "Choose a file"}  // Show file name inside the input box
        onClick={() => fileInputRef.current.click()} // Trigger file input when clicked
        readOnly
      />
      <p className="text-danger">{errors?.imgprofile?.message}</p>
    </div>
    </>
  )
}

UploadImage.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  onFileChange: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired, 
};

export default UploadImage